/* MUTI Insights: Lesefortschritt, Inhaltsverzeichnis, Teilen */
(() => {
  const article = document.querySelector('[data-mi-article]');
  if (!article) return;

  const content = article.querySelector('[data-mi-content]');

  /* Lesefortschritt ------------------------------------------------------ */
  const bar = document.querySelector('[data-mi-progress]');
  if (bar && content) {
    let ticking = false;
    const update = () => {
      const rect = content.getBoundingClientRect();
      const total = rect.height - window.innerHeight * 0.6;
      const read = -rect.top + window.innerHeight * 0.25;
      const progress = Math.min(Math.max(read / Math.max(total, 1), 0), 1);
      bar.style.transform = `scaleX(${progress})`;
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* Inhaltsverzeichnis --------------------------------------------------- */
  const toc = article.querySelector('[data-mi-toc]');
  const list = article.querySelector('[data-mi-toc-list]');

  if (toc && list && content) {
    const levels = ['H2', 'H3', 'H4'];
    const all = Array.from(content.querySelectorAll('h2, h3, h4')).filter((h) => h.textContent.trim().length > 1);
    const topLevel = levels.find((level) => all.filter((h) => h.tagName === level).length >= 2);
    const headings = topLevel ? all.filter((h) => h.tagName === topLevel) : [];

    if (headings.length >= 2) {
      const used = new Set();
      const slugify = (text) => {
        let slug = text
          .toLowerCase()
          .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
          .normalize('NFKD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 60) || 'abschnitt';
        let unique = slug;
        let i = 2;
        while (used.has(unique) || document.getElementById(unique)) unique = `${slug}-${i++}`;
        used.add(unique);
        return unique;
      };

      const links = headings.map((heading) => {
        if (!heading.id) heading.id = slugify(heading.textContent.trim());
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${heading.id}`;
        a.textContent = heading.textContent.trim().replace(/\s+/g, ' ').replace(/^\d+\.\s*/, '');
        li.appendChild(a);
        list.appendChild(li);
        return a;
      });

      toc.hidden = false;

      const details = toc.querySelector('details');
      const desktop = window.matchMedia('(min-width: 1150px)');
      const syncOpen = () => { if (details) details.open = desktop.matches; };
      syncOpen();
      desktop.addEventListener('change', syncOpen);

      list.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link) return;
        event.preventDefault();
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', link.hash);
        if (!desktop.matches && details) details.open = false;
      });

      if ('IntersectionObserver' in window) {
        const setActive = (index) => links.forEach((a, i) => a.setAttribute('aria-current', i === index ? 'true' : 'false'));
        const observer = new IntersectionObserver(() => {
          const offset = window.innerHeight * 0.3;
          let active = -1;
          headings.forEach((heading, i) => {
            if (heading.getBoundingClientRect().top - offset <= 0) active = i;
          });
          setActive(Math.max(active, 0));
        }, { rootMargin: '0px 0px -60% 0px', threshold: [0, 1] });
        headings.forEach((heading) => observer.observe(heading));
      }
    }
  }

  /* Teilen ---------------------------------------------------------------- */
  const shareButton = article.querySelector('[data-mi-share]');
  const copyButton = article.querySelector('[data-mi-copy]');
  const url = window.location.href.split('#')[0];

  if (shareButton && navigator.share) {
    shareButton.hidden = false;
    shareButton.addEventListener('click', () => {
      navigator.share({ title: document.title, url }).catch(() => {});
    });
  }

  if (copyButton) {
    const original = copyButton.textContent;
    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
        copyButton.textContent = copyButton.dataset.copiedLabel || original;
        setTimeout(() => { copyButton.textContent = original; }, 2000);
      } catch (error) {
        window.prompt('Link kopieren:', url);
      }
    });
  }
})();
